import * as Sentry from "@sentry/react";

import { env } from "@/env";

const SENTRY_ENVIRONMENT_BY_HOST: Record<string, string> = {
  "pharmacie.meditect.com": "prod",
  "pharmacie-preprod.meditect.com": "preprod",
};

const isLocalHost = ["localhost", "127.0.0.1", "[::1]"].includes(location.hostname);

Sentry.init({
  dsn: "https://bc9eaf4b7c49b9998bd8dcad4860cc2e@o4506970739113984.ingest.us.sentry.io/4506970740293632",
  enabled: import.meta.env.PROD && !isLocalHost,

  // Set tracesSampleRate to 1.0 to capture 100%
  environment: SENTRY_ENVIRONMENT_BY_HOST[location.hostname] ?? "unknown",

  ignoreErrors: [
    // Ancre de fin : "Failed to fetch dynamically imported module" est un chunk Vite
    // manquant, pas une coupure reseau, et doit rester visible.
    /Failed to fetch$/,
    "NetworkError when attempting to fetch resource",
    "auth/network-request-failed",
  ],

  release: env.REACT_APP_RELEASE,

  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      blockAllMedia: false,
      maskAllInputs: false,
      maskAllText: false,
    }),
  ],

  // Capture Replay for 10% of all sessions,
  replaysOnErrorSampleRate: 1,
  // plus for 100% of sessions with an error
  replaysSessionSampleRate: 0.1,

  // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ["localhost", /^https:\/\/api-/],
  // of transactions for performance monitoring.
  tracesSampleRate: 0.1,

  // Offline event capture
  transport: Sentry.makeBrowserOfflineTransport(Sentry.makeFetchTransport),
});
